(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["four-column-product-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFewItemsSlider(el) {
      if (!el || el.dataset.fewItemsInit === '1') return;
      if (typeof Swiper === 'undefined') return;

      if (el.swiper && typeof el.swiper.destroy === 'function') {
        el.swiper.destroy(true, true);
      }

      var instance = new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        grabCursor: false,
        loop: false,
        watchOverflow: true,
        updateOnWindowResize: true,
        direction: 'horizontal',
        threshold: 1,
        breakpoints: {
          769: { spaceBetween: 20 },
        },
        navigation: {
          nextEl: '.swiper-button-next-product-slider',
          prevEl: '.swiper-button-prev-product-slider',
        },
        on: {
          lock: function () { el.classList.add('is-locked'); },
          unlock: function () { el.classList.remove('is-locked'); },
        },
      });

      if (instance && instance.isLocked) {
        el.classList.add('is-locked');
      }

      el.dataset.fewItemsInit = '1';
    }

    function initAll() {
      var nodes = document.querySelectorAll('.four-column-product-slider.few-items .js__product-slider');
      nodes.forEach(initFewItemsSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        setTimeout(initAll, 0);
      });
    } else {
      setTimeout(initAll, 0);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
